import { RefObject, useEffect, useRef } from 'react'

import { Chamada } from '../model-chamadaPainel'

export function useChamadaAudio(
  chamadaAtual: Chamada | null,
  isChamando: boolean,
  audioRef: RefObject<HTMLAudioElement>
) {
  const playPromiseRef = useRef<Promise<void> | undefined>()

  useEffect(() => {
    const audioElement = audioRef.current
    if (!audioElement) return

    if (isChamando && chamadaAtual) {
      audioElement.currentTime = 0
      playPromiseRef.current = audioElement.play()

      if (playPromiseRef.current !== undefined) {
        playPromiseRef.current.catch(() => {})
      }
    } else {
      const stopAudio = () => {
        audioElement.pause()
        audioElement.currentTime = 0
      }

      if (playPromiseRef.current !== undefined) {
        playPromiseRef.current.then(stopAudio).catch(() => {
          stopAudio()
        })
      } else {
        stopAudio()
      }
    }
  }, [chamadaAtual, isChamando, audioRef])

  useEffect(() => {
    const audioElement = audioRef.current
    return () => {
      if (audioElement) {
        audioElement.pause()
        audioElement.currentTime = 0
      }
    }
  }, [audioRef])
}
